export interface LinkProp {
  label: string
  link: string
}

export interface ImageProp {
  link: string
  altText: string
}

export interface ActionProp {
  type: string
  link?: LinkProp
  label?: string
  newFeatureCenterId?: string
}

export interface AlertContentProp {
  content: string
  textColor?: 'base' | 'secondary' | 'tertiary'
  fontSize?: 'extraLarge' | 'large' | 'medium' | 'base' | 'small' | 'mini' | 'tiny'
}

export enum ActionType {
  OPEN_EXTERNAL_ACTION = 'OPEN_EXTERNAL_ACTION',
  OPEN_INTERNAL_ACTION = 'OPEN_INTERNAL_ACTION',
  OPEN_NEW_FEATURE_CENTER = 'OPEN_NEW_FEATURE_CENTER',
}

export enum WidgetStatus {
  DISMISSED = 'DISMISSED',
}
